import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBack from "@material-ui/icons/ArrowBack";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import AppBar from "@material-ui/core/AppBar";
import {useHistory, useParams} from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import DashboardFooter from '../../components/DashboardFooter';

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingRight: '10%',
    paddingLeft: '10%',
    paddingTop: '70px',
    height: '100%',
  },
  initiativeHeader: {
    fontSize: '24px'
  }
}));

export default function InitiativeBackLayout(props) {
  const classes = useStyles();
  const history = useHistory();
  const params = useParams();
  const { hideContentAndFooter, children, backUrl} = props;

  // Methods
  const handleBackButton = () => {
    history.push(backUrl? backUrl: `/ui/initiativecard/${params.id}`);
  };

  return (
    <div id={!!hideContentAndFooter? null : "body-container"}>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleBackButton}
            className={classes.menuButton}
          >
            <ArrowBack />
          </IconButton>
          <div className={classes.initiativeHeader}> Initiative: {params.id}</div>
        </Toolbar>

      </AppBar>
      {!!!hideContentAndFooter &&
          <div className={classes.wrapper}>
            {children}
          </div>
        }
      {!!!hideContentAndFooter && <DashboardFooter />}
    </div>
  );
}
